import { Input } from 'antd';
import { useEffect, useRef } from 'react';

interface Props {
    searchParams: URLSearchParams;
    handleSearch: (value: string) => void;
    fetchResults: () => void;
    loading: boolean;
}

const { Search: AntdSearch } = Input;

const Search = ({
    handleSearch, fetchResults, searchParams, loading,
}: Props) => {
    const inputRef = useRef<any>(null);
    const search = searchParams.get('search') || '';

    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.focus();
        }
    }, [loading]);

    return (

        <AntdSearch
            ref={inputRef}
            defaultValue={search}
            loading={loading}
            allowClear
            enterButton
            onSearch={fetchResults}
            onChange={(e) => handleSearch(e.target.value)}
            disabled={loading}
            style={{
                minHeight: 32,
                maxWidth: '100%',
                fontSize: 14,
            }}
            size="large"
        />
    );
};

export default Search;
